import React from 'react';
import { CircularProgress } from '@mui/material';
import './blog.scss';
import { useInfo } from '../../context';
import { Theme } from '../../config';
import BLOG from '../../assets/images/Blogs/PrispekZoom.jpg';
import Electricity from '../../assets/images/Blogs/electricity.jpg';
import { Navbar, Footer, BlogPost, Alert } from '..';

export const BlogsPage: React.FC = React.memo(() => {
    const { blogs, getBlogs, getBlogsResponse } = useInfo();
    const topRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        getBlogs();
    }, [getBlogs]);
    return (
        <section ref={topRef}>
            <Alert
                closeHandler={getBlogsResponse.closeAlert}
                {...getBlogsResponse.alert}
            />
            <Navbar blog={true} />
            <div className='blog' style={{ background: Theme.background }}>
                {getBlogsResponse.loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <BlogPost
                            blog={{
                                Title: 'Is the POWER coming back on?',
                                DatePosted: new Date('2022/09/11'),
                                Description:
                                    'Have we weathered the storm?',
                                ReadMore: JSON.stringify([
                                    {
                                        Guid: '1',
                                        description:
                                            "Jeremy Gardner, Ninety One Director, provides thought provoking insights into the past 6 months"
                                    },
                                ]),
                                Link: 'https://ninetyone.com/en/south-africa/events/taking-stock-weathering-the-storm?role=Financial+Advisor&utm_source=pardot&utm_medium=email&utm_content=image-link&utm_campaign=taking-stock#ha9n5HyEKptGHVyxir39Jd',
                                LinkTip: 'Click here',
                                CoverImage: Electricity
                            }}
                        />
                        <BlogPost
                            blog={{
                                Title: 'Section 12J Webinar',
                                DatePosted: new Date('2021/06/14'),
                                Description:
                                    'We would like to invite you to a 40 minute online Section 12J investment webinar co-hosted with Jaltech Fund Managers. The webinar is for individuals, companies and trusts who are paying a reasonable amount of income tax or capital gains tax in this financial year.',
                                ReadMore: JSON.stringify([
                                    {
                                        Guid: '1',
                                        description:
                                            "The webinar will enhance your understanding of the Section 12J tax incentive which is coming to an end at the end of this month as well as provide you with insight into Jaltech's investments and funding option for investors."
                                    },
                                    {
                                        Guid: '2',
                                        description:
                                            'The webinar will be held via Zoom on 14 June at 12h00.'
                                    },
                                    {
                                        Guid: '3',
                                        description:
                                            'To RSVP, please click on the below button and register.'
                                    }
                                ]),
                                Link: 'https://zoom.us/webinar/register/WN_Libff_5BRTCCQ0MkJUNHcg',
                                LinkTip: 'CLICK HERE TO RSVP',
                                CoverImage: BLOG
                            }}
                        />
                        {blogs.map(blog => (
                            <BlogPost key={blog.Guid} blog={blog} />
                        ))}
                    </>
                )}
            </div>
            <Footer />
        </section>
    );
});
